import React, { useState } from 'react'
import { ReactComponent as DownIcon } from '../../assets/images/down.svg'
import classes from './coursecontent.module.css'
import classNames from 'classnames'

const CourseContent = ({ title, lectures }) => {
    const [open, toggleOpen] = useState(false)
    return (
        <div className={classes.courseContent}>
            <button
                className={classes.courseHeader}
                onClick={() => toggleOpen(!open)}
            >
                <DownIcon
                    className={[
                        classes.courseHeaderImage,
                        open && classes.courseHeaderImageRotate,
                    ].join(' ')}
                />
                <span className={classes.courseHeaderText}>{title}</span>
            </button>
            <div
                className={classNames(
                    classes.courseLectures,
                    open && classes.courseLecturesActive
                )}
                style={{
                    '--lectures-desktop-height': `${lectures.length * 62}px`,
                    '--lectures-mobile-height-closed': `${(lectures.length -
                        1) *
                        40}px`,
                    '--lectures-mobile-height-open': `${lectures.length * 40 +
                        20}px`,
                }}
            >
                {lectures.map((lecture, idx) => (
                    <div className={classes.courseLecture} key={idx}>
                        {lecture}
                    </div>
                ))}
            </div>
            <button
                className={classes.showLecturesButton}
                onClick={() => toggleOpen(!open)}
            >
                {open ? 'Hide Lesson Items' : 'Show all lesson items'}
                <DownIcon
                    className={classNames(
                        classes.showLecturesButtonIcon,
                        open && classes.showLecturesButtonIconRotate
                    )}
                />
            </button>
        </div>
    )
}

export default CourseContent
